export const REFRESH_TOKEN_INTERVAL_TIME = 60000;
export const CHECK_TOKEN_INTERVAL_TIME = 3000;

export const DURATION_TYPES = {
    YEAR: {
        key: 'YEAR',
        label: 'invoices.years',
        code: 'yr',
        momentUnitOfTime: 'years',
    },
    MONTH: {
        key: 'MONTH',
        label: 'invoices.months',
        code: 'mo',
        momentUnitOfTime: 'months',
    },
    DAY: {
        key: 'DAY',
        label: 'invoices.days',
        code: 'd',
        momentUnitOfTime: 'days',
    },
};

export const PRODUCT_TYPE = {
    DOMAIN: 'DOMAIN',
    CLOUD_SERVER: 'CLOUD_SERVER',
    CLOUD_HOSTING: 'CLOUD_HOSTING',
    SHARED_HOSTING: 'SHARED_HOSTING',
    SMS_BRAND_NAME: 'SMS_BRAND_NAME',
    WORDPRESS_HOSTING: 'WORDPRESS_HOSTING',
    SSL: 'SSL',
    AWS: 'AWS',
};

export const DEFAULT_PHONE_COUNTRY_CODE = 'KH';

export const DATE_TIME_FORMAT = 'DD/MM/YYYY';

export const DATE_FORMAT_WITH_TIME = 'DD/MM/YYYY HH:mm:ss';
export const DATE_FORMAT_WITH_SHORT_TIME = 'DD/MM/YYYY HH:mm';
export const DATE_FORMAT_FULL_DATE_TIMEZONE = 'DD/MM/YYYY HH:mm:ss (UTCZ)';
export const DATE_FORMAT_FULL_DATE_SHORT_TIMEZONE = 'DD/MM/YYYY HH:mm:ss Z';

export const VALUE_TYPE_ISO_STRING = {
    from: 'YYYY-MM-DDT00:00:00.000Z',
    to: 'YYYY-MM-DDT23:59:59.999Z',
};

export const PRIORITIZED_COUNTRY = ['TH', 'KH', 'VN', 'AE'];

export const COUNTRY_CODE_NEED_TO_VALIDATE_POSTAL_CODE = ['CA', 'US'];

export const INTERIOR_COUNTRY_CODE = {
    KH: 'KH',
    AE: 'AE',
    TH: 'TH',
};

export const DEFAULT_COUNTRY = {
    ISOCountryCode: 'KH',
    CountryName: 'Cambodia',
    CountryCode: '855',
};

export const REFUND_TYPE = {
    SMS: {
        value: 'SMS',
        key: 'SMS',
    },
};

export const REFUND_TYPE_SHOW_REF = [REFUND_TYPE.SMS.key];
export const REFUND_REF_LINK = {
    SMS: {
        routerName: 'sms.detail',
        linkTitle: 'sms.go_to_this_transaction',
    },
};
export const DEFAULT_NUMBER_LOCALE = 'en-GB';

export const WEBSITES = {
    KH: 'KH',
    AE: 'AE',
    TH: 'TH',
};

export const LOCALES = {
    KM: 'km',
    EN: 'en',
};

export const NODE_RSA_CONFIG = {
    BITS: 200,
    OPTION_ENCRYPTION_SCHEME: 'pkcs1',
    OPTION_ENVIRONMENT: 'browser',
    IMPORT_KEY_FORMAT: 'public',
    ENCRYPT_ENCODING: 'base64',
    ENCRYPT_SOURCE_ENCODING: 'utf8',
};

export const OTP_COMPLETED_TIMEOUT = 100;

export const SOFT_STATUS_KEY_LENGTH = 32;

export const DEFAULT_CONFIRM_MODAL_ID = 'alert_confirm';
export const DEFAULT_ALERT_MODAL_ID = 'alert_modal';

export const FULL_SCREEN_ROUTE_NAMES = ['invoices.payment-success'];

export const THEMES = {
    DEFAULT: {
        key: 'DEFAULT',
        folderName: 'default',
    },
    XMAS: {
        key: 'XMAS',
        folderName: 'xmas',
    },
    SPRING: {
        key: 'SPRING',
        folderName: 'spring',
    },
    SUMMER: {
        key: 'SUMMER',
        folderName: 'summer',
    },
};

export const DEBOUNCE_TIMER_IN_MILLISECOND = 2000;

export const HTTP = 'http://';

export const HTTP_WWW = 'http://www.';

export const DAYS_OF_WEEK = {
    MONDAY: {
        key: 'MONDAY',
        value: 1,
        translateKey: 'common.monday',
    },
    TUESDAY: {
        key: 'TUESDAY',
        value: 2,
        translateKey: 'common.tuesday',
    },
    WEDNESDAY: {
        key: 'WEDNESDAY',
        value: 3,
        translateKey: 'common.wednesday',
    },
    THURSDAY: {
        key: 'THURSDAY',
        value: 4,
        translateKey: 'common.thursday',
    },
    FRIDAY: {
        key: 'FRIDAY',
        value: 5,
        translateKey: 'common.friday',
    },
    SATURDAY: {
        key: 'SATURDAY',
        value: 6,
        translateKey: 'common.saturday',
    },
    SUNDAY: {
        key: 'SUNDAY',
        value: 0,
        translateKey: 'common.sunday',
    },
};

export const SIGNATURE = {
    EXPIRED_SECOND: 120,
    MESSAGE: '1byte',
};

export const ORDER_ACTION_TYPE = {
    REGISTER: 'REGISTER',
    RENEW: 'RENEW',
    REACTIVATE: 'REACTIVATE',
    TRANSFER: 'TRANSFER',
    PURCHASE: 'PURCHASE',
    UPGRADE: 'UPGRADE',
    BACKUP: 'BACKUP',
};
